export const ERROR = 'error';
export const SET_ERROR = 'setError';